import React from 'react';

import {Helmet} from "react-helmet";

const Error404 = () => {
  return (
    <div id="not_found">
    <Helmet>
          <meta charSet="utf-8" />
          <meta name="robots" content="noindex, nofollow" />
          <link rel="shortcut icon" type="image/png" href="/public/Icon.png" />
          <title>Планета Рыбака - 404</title>
          <link
            rel="canonical"
            href="https://rybalka-md.com"
          />
          <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        </Helmet>
      <div className="conatiner">
        <div style={{
          fontSize: '30px',
          fontWeight: "bold",
          marginBottom: '370px',
          marginTop: '50px',
          paddingTop: '50px'
        }}>
          <h1 className="all_products_title" style={{
            marginTop: '30px'
          }}>
            Такой страницы не существует...
          </h1>
        </div>
      </div>
    </div>
  );
};

export default Error404;